import { Box, Flex } from '@chakra-ui/react';

import { Iteration } from 'Component/others';
import SkeletonComponent from 'UiKit/skeleton';

import styles from './styles.module.css';

const TalkingPointItemSkeleton = () => {
  return (
    <Box border="1px solid var(--color-neutral20)" borderRadius="8px" padding="12px" mb="8px">
      <SkeletonComponent height="16px" width="140px" mb="12px" />
      <Flex flexDirection="column" gap="8px">
        <SkeletonComponent height="14px" width="90%" />
        <SkeletonComponent height="14px" width="75%" />
        <SkeletonComponent height="14px" width="60%" />
      </Flex>
    </Box>
  );
};

const TalkingPointContentSkeleton = () => {
  return (
    <Box className={styles['content__container']}>
      <Iteration
        items={[1, 2, 3]}
        render={(item) => <TalkingPointItemSkeleton key={item} />}
      />
    </Box>
  );
};

export default TalkingPointContentSkeleton;
